// @ts-check

import { useAssignmentDataGridContext } from '~/components/Forms/AssignmentDataGrid/AssignmentDataGrid.context';
import GridExportButton from '~/components/Shared/DataGrid/GridExportButton';

const EXPORTED_ROW_COUNT = 125;

export default function AssignmentDataGridExportButton() {
    const { gridRef, setRowCount } = useAssignmentDataGridContext();

    return (
        <GridExportButton
            gridRef={gridRef}
            setRowCount={setRowCount}
            exportRowCount={EXPORTED_ROW_COUNT}
            fileName="ZERO Assignments Export"
        />
    );
} 